// extracted by mini-css-extract-plugin
export default {"dialog":"styles_dialog__hlxe1","ErrorModal":"styles_ErrorModal__53ceM","content":"styles_content__vcwps","message":"styles_message__hFKaN"};